export enum Page {
  Setup = 'Setup',
  Configure = 'Configure',
  Manage = 'Manage',
  Display = 'Display',
  Sort = 'Add Sort Criteria',
  Filters = 'Add Filters'
}
